module.exports = __webpack_public_path__ + "europa-20_back.jpg?32d0dd7cd3fe437fc847145cb3863a40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_back.jpg
// module id = 330
// module chunks = 0